module.exports = __webpack_public_path__ + "ENG_SPS3-NewFriends-9adb3e8c3b222edec4ce7f5244167f09.png";